/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.platform-reach-container[_ngcontent-%COMP%]{margin:0 15px 0 32px;padding:21px 0}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/platform-reache/platform-reache.component.scss.shim.ngstyle.js.pre-build-optimizer.js